import img from "../../mapImages/CustomsHiddenStashes.webp";
import { MapGroupId } from "../../types";

const mapData = {
  groupId: MapGroupId.Customs,
  groupName: {
    en: "Customs",
    ru: "Таможня",
  },
  title: {
    en: "Hidden Stashes",
    ru: "Тайники",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
